import React from "react";

import {RoleListComponent} from "ppm-react-authentication";
import {ROLES_API_URL, ROLES_PERMISSIONS_API_URL} from "../../helpers/api-urls";
import { Link } from "react-router-dom";
import AuthorizationChecker from "security/AuthorizationChecker";
import { withTranslation } from "react-i18next";

const PagesRoles = (props) => {

    return (
    <>
        <div className="page-content">
                <title>{props.t("ROLE")}</title>
                
            <RoleListComponent 
                apiUrl={ROLES_API_URL}
                apiRolePermissionUrl={ROLES_PERMISSIONS_API_URL}
                addUrl="/pages-roles/add"
                path="/pages-roles"
                Link={Link}
                showAdd = { AuthorizationChecker.isGranted(["ADD_ROLES"])}
                showEdit = { AuthorizationChecker.isGranted(["EDIT_ROLES"])}
                showView = { AuthorizationChecker.isGranted(["READ_ROLES"])}
                showDelete  = { AuthorizationChecker.isGranted(["DELETE_ROLES"])}
            />
        </div>
    </>
    )
}

export default withTranslation()(PagesRoles)
